import { render, staticRenderFns } from "./quitPersonList.vue?vue&type=template&id=429f90aa&scoped=true"
import script from "./quitPersonList.vue?vue&type=script&lang=js"
export * from "./quitPersonList.vue?vue&type=script&lang=js"
import style0 from "./quitPersonList.vue?vue&type=style&index=0&id=429f90aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429f90aa",
  null
  
)

export default component.exports